import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderFullpageComponent } from './loader-fullpage.component';

/** The fullpage loader module. Each component is broken in to it's own module for tree shaking reasons. */
@NgModule({
    imports: [ CommonModule, MatProgressSpinnerModule, ReactiveFormsModule, FormsModule ],
    declarations: [ LoaderFullpageComponent ],
    exports: [ LoaderFullpageComponent ]
})
export class LoaderFullpageModule {}
